import React from 'react'
import { NoChartDataIcon } from '../icons/Icons'

import classes from './styles.module.scss'
import classNames from 'classnames'

interface Props {
  text: string
  isUserData?: boolean
}

const NoChartData: React.FC<Props> = ({ text, isUserData = false }) => {
  // Split the text by <br /> tag to create multiple paragraphs
  const textParts = text.split('<br />')

  return (
    <div className={classNames(classes.container, [
      isUserData && classes.noUsersDataContainer
    ])}>
      <NoChartDataIcon />
      {textParts.map((part, index) => (
        <p key={index} className={classes.text}>{part}</p>
      ))}
    </div>
  )
}

export default NoChartData
